// ============================================================
// Feature flags — pages that exist in the repo but are hidden
// until their real backend exists.
// ============================================================
// 2026-06-11 honesty pass (panel review, docs/audit-2026-06-11-panel-review.md):
// a settings/token page that LOOKS functional but persists nothing fails
// enterprise security review worse than its absence. Flip a flag to true
// only when the corresponding backend actually works.
//
// Removed outright in the same pass (routes + nav deleted, files kept):
// /speed-test, /pay, /admin/health, /optimizer, /admin/billing, /team,
// /dashboards, /admin/api-console, and the inline plan-change cards on
// /service-lines (single write path = /requests/new).

export const FEATURES = {
  // SAML/OIDC federation settings — UI only today; enable when Cognito
  // IdP federation is wired and the form persists to a real backend.
  SSO_SETTINGS: false,
  // SCIM provisioning — enable when tokens are actually issued + honored.
  SCIM_SETTINGS: false,
  // Customer API tokens — backend live 2026-06-14 (/api-tokens, RDS-backed,
  // hash-only, plaintext shown once). Page is wired to it.
  API_ACCESS: true,
  // These pages currently calculate from demo fixtures or synthesized
  // values. Keep them out of production navigation until their real history,
  // scheduling, SLA and export contracts are backed by tenant-scoped APIs.
  ENTERPRISE_ANALYTICS: false,
  // Tenant-scoped operational controls and observed firmware inventory.
  // Backed by the Operations Lambda + RDS migration 0051.
  ALERT_RULES: true,
  MAINTENANCE_WINDOWS: true,
  FLEET_GROUPS: true,
  FIRMWARE_INTELLIGENCE: true,
};
